module.exports = __webpack_public_path__ + "static/MariVircik-05d679e0cf2a864039422a5ec4c694d7.jpg";